import { useState, useEffect } from 'react';

interface BreakpointState {
  isXs: boolean;      // < 360px
  isSm: boolean;      // < 640px
  isMd: boolean;      // < 768px
  isLg: boolean;      // < 1024px
  isXl: boolean;      // < 1280px
  is2xl: boolean;     // >= 1280px
  isDesktop: boolean; // >= 1024px (for desktop-specific layouts)
  isMobile: boolean;  // < 1024px (for mobile-specific layouts)
  width: number;
  height: number;
}

export function useResponsiveBreakpoints(): BreakpointState {
  const [breakpoints, setBreakpoints] = useState<BreakpointState>({
    isXs: false,
    isSm: false,
    isMd: false,
    isLg: false,
    isXl: false,
    is2xl: false,
    isDesktop: false,
    isMobile: true,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const updateBreakpoints = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setBreakpoints({
        isXs: width < 360,
        isSm: width < 640,
        isMd: width < 768,
        isLg: width < 1024,
        isXl: width < 1280,
        is2xl: width >= 1280,
        isDesktop: width >= 1024,
        isMobile: width < 1024,
        width,
        height,
      });
    };

    // Set initial values
    updateBreakpoints();

    // Add event listener
    window.addEventListener('resize', updateBreakpoints);

    // Cleanup
    return () => window.removeEventListener('resize', updateBreakpoints);
  }, []);

  return breakpoints;
}

export default useResponsiveBreakpoints;
